import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/IndexRepository'


class IndexBloc {

    pensiunListChannel = new Subject();
    workUnitChannel = new Subject();
    repository = new DetailRepository()
    constructor() {
        this.pensiunListChannel.next({status: apiResponse.INITIAL})
        this.workUnitChannel.next({status: apiResponse.INITIAL})
    }

    fetchPensiunList = async (query) => {
       try {
           this.pensiunListChannel.next({status: apiResponse.LOADING})
           await this.repository.fetchPensiunList(query).then((result) => {
               this.pensiunListChannel.next({status: apiResponse.COMPLETED, data: result})
           }).catch((error) => {
               this.pensiunListChannel.next({status: apiResponse.ERROR, data: error})
           })
       } catch (error) { console.log("unsubscribed")}
    }
    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
}

export default IndexBloc